import { replaceOperation } from '../../product/operations';
import { editPhotos } from '../photos';

import { EMPTY } from '../../../constants';

export function photos({ operation, product, ...rest }) {
  const value = operation.get('value');
  const updates = editPhotos({ product, value });

  return {
    ...rest,
    product: updates.product = updates.product.set('operations',
      updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
    ),
  };
}
